 <template>
 <!-- Lock Rate Modal -->
  <modal :isOpen=isLockRateModalOpen @close-modal="closeLockRateModal" :showClose="true">
    <template v-slot:content>
      <div class="price-lock-modal">
        <img class="summary__lock-rate-logo" :src="themeLogo" />
        <h3 class="summary__lock-rate-heading">Not quite ready to complete your order?</h3>
        <p class="price-lock-modal__description">Don't worry. We can send you an email with your dumpster quote, and you can complete your order at a later time.</p>
        <p class="price-lock-modal__description"><strong>Please note:</strong> Due to changing availability and pricing, your quoted price will only be reserved for 14 days.</p>
        <form @submit.prevent="lockRate">
          <label>
            <input class="input" required type="text" v-model="lockRateName" placeHolder="Name *" />
          </label>
          <label>
            <input class="input" required type="email" v-model="lockRateEmail" placeHolder="Email Address *" />
            <img class="price-lock-modal__icon" :src="envelope">
          </label>
          <dismissable :isWarning="true" v-if="showError">
            <template v-slot:content>
              <p>Oops, something went wrong</p>
            </template>
          </dismissable>
          <button :disabled="isLockRateInProgress" class="btn btn--secondary mt-1 price-lock-modal__save">
            Save My Cart
            <img class="price-lock-modal__save-icon" :src="iconArrowRight" />
          </button>
        </form>
        <small class="price-lock-modal__disclaimer mt-1">By sending this quote, you agree to {{ companyNamePossesive }} <a :href="privacyPolicy" target="_blank">Privacy Policy</a> and <a :href="termsOfUse" target="_blank">Terms of Use.</a></small>
      </div>
    </template>
  </modal>

  <!-- Lock Rate Confirmation Modal -->
  <modal class="lockrate-modal" :isOpen=isLockRateConfirmationModalOpen @close-modal="closeLockRateConfirmationModal" :showClose="true">
    <template v-slot:content>
      <div>
        <img class="lockrate-modal__img" :src="themeLogo" />
        <h3 class="lockrate-modal__heading">Thank You!</h3>
        <p>We've sent your dumpster quote to <strong>{{ lockRateEmail }}</strong>.</p>
        <p><strong>Your quote will be valid for 14 days.</strong><br><br></p>
        <p>When you're ready to order, click the link included in your email, or give us a call at <span class="lockrate-modal__phone">{{ phoneNumber }}</span> during business hours.</p>
        <button v-on:click="closeLockRateConfirmationModal" class="btn mt-1 lockrate-modal__close">
          Return to My Order
        </button>
      </div>
    </template>
  </modal>
</template>

<script>
import { mapState } from 'vuex'
import dismissable from '@/components/Dismissable.vue'
import modal from '@/components/Modal.vue'
import config from '@/config'
const { cdn, companyNamePossesive, phoneNumber, links: { privacyPolicy, termsOfUse } } = config

export default {
  components: {
    dismissable,
    modal
  },
  data () {
    return {
      themeLogo: `${cdn}theme-logo.png`,
      cartIcon: `${cdn}icons-cart.svg`,
      pinIcon: `${cdn}icons-address-marker.svg`,
      saveIcon: `${cdn}icons-save-cart.svg`,
      iconArrowRight: `${cdn}icons-arrow-right.svg`,
      calendarIcon: `${cdn}icons-calendar.svg`,
      envelope: `${cdn}envelope.svg`,
      privacyPolicy,
      termsOfUse,
      companyNamePossesive,
      phoneNumber
    }
  },
  methods: {
    closeLockRateConfirmationModal () {
      this.$store.commit('lockRate/toggleLockRateConfirmationModal', false)
    },
    closeLockRateModal () {
      this.$store.commit('lockRate/closeLockRateModal')
    },
    lockRate () {
      this.$store.dispatch('lockRate/executeLockRate')
    }
  },
  computed: {
    ...mapState('lockRate', [
      'showError',
      'isLockRateModalOpen',
      'isLockRateConfirmationModalOpen',
      'isLockRateInProgress'
    ]),
    lockRateName: {
      get () {
        return this.$store.state.lockRate.lockRateName
      },
      set (val) {
        return this.$store.commit('lockRate/lockRateName', val)
      }
    },
    lockRateEmail: {
      get () {
        return this.$store.state.lockRate.lockRateEmail
      },
      set (val) {
        return this.$store.commit('lockRate/lockRateEmail', val)
      }
    }
  }
}
</script>
